import { Package, Sprout } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  iconImage: "https://thebarndesk.com/wp-content/uploads/2026/05/Feature-icons-01.png",
  title: "Animal Tracking",
  description: "Health notes, weights, photos, and history tied to the animal they belong to. And when you sell, hand the buyer a one-page packet — or transfer the whole record to their BarnDesk farm."
}, {
  icon: Sprout,
  title: "Breeding & Pedigrees",
  description: "Natural cover or AI with straw inventory, due dates that set themselves, 3-generation pedigrees with registration numbers, and sire performance rankings that show who's earning his keep."
}, {
  iconImage: "https://thebarndesk.com/wp-content/uploads/2026/05/Feature-icons-02.png",
  title: "Chores",
  description: "Recurring tasks for the things that repeat — plus birth-triggered care schedules for CD&T, banding, and weaning that follow YOUR farm's practices, not somebody else's."
}, {
  iconImage: "https://thebarndesk.com/wp-content/uploads/2026/05/Feature-icons-06.png",
  title: "Tax & USDA Ready",
  description: "Receipts auto-sorted into Schedule F line items, and USDA disaster forms (like LFP) pre-filled from records you already keep. The paperwork nobody else does for you."
}, {
  icon: Package,
  title: "Inventory",
  description: "Feed, minerals, medications, and supplies. Know what's on hand and what needs reordered before you run out."
}, {
  iconImage: "https://thebarndesk.com/wp-content/uploads/2026/05/Feature-icons-04.png",
  title: "Equipment Care",
  description: "Hours, service dates, repairs, and maintenance notes for the tractor, UTV, implements, and anything else that breaks at the wrong time."
}];
export default function PilaresAcademicos() {
  useRevealOnScroll();
  return <section data-section-id="features" id="features" className="bg-background py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className="reveal-on-scroll text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm font-medium text-chart-2 uppercase tracking-wide mb-3">
            Six things every family farm tracks
          </p>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
            One app for the records your farm actually needs.
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Animals, breeding, chores, inventory, equipment, and the tax and USDA paperwork that comes with all of it. Built for how real farms run.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {pillars.map(pillar => {
          const Icon = pillar.icon;
          return <div key={pillar.title} className="reveal-on-scroll bg-card border border-border rounded-2xl p-6 hover:border-chart-2/40 hover:shadow-lg transition-all">
                <div className="w-14 h-14 rounded-xl bg-chart-2/10 flex items-center justify-center mb-5">
                  {pillar.iconImage ? <img src={pillar.iconImage} alt={pillar.title} className="w-10 h-10 object-contain" /> : Icon ? <Icon strokeWidth={1.5} className="w-7 h-7 text-chart-2" /> : null}
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  {pillar.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {pillar.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}